import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulse, Home, RefreshCw, Target } from 'lucide-react';
const targets = [{
  icon: <HeartPulse size={32} className="text-brand-orange" data-id="element-293" />,
  title: '👩 Mamás agotadas de vivir en alerta permanente',
  desc: 'Madres de niños asmáticos que ya probaron de todo y siguen viendo a su hijo terminar en la guardia cada mes.'
}, {
  icon: <Home size={32} className="text-brand-green" data-id="element-294" />,
  title: '🏠 Vivís en cualquier ciudad de Argentina',
  desc: 'Con lo que tenés en casa y en la verdulería del barrio te alcanza. Sin remedios caros ni equipos especiales.'
}, {
  icon: <RefreshCw size={32} className="text-brand-gold" data-id="element-295" />,
  title: '🆕 Mamás que quieren pasar de reactivas a preventivas',
  desc: 'Querés dejar de apagar incendios y empezar a anticiparte a las crisis antes de que ocurran.'
}, {
  icon: <Target size={32} className="text-brand-amber" data-id="element-296" />,
  title: '🎯 Buscás resultados concretos',
  desc: 'Vas por menos guardias, menos noches interrumpidas, menos inhalador y un hijo que pueda correr, reír y vivir sin miedo.'
}];
export const WhoIsItFor = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-brand-green text-white" data-id="element-297">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-298">
        <div className="text-center mb-8 sm:mb-12 md:mb-16" data-id="element-299">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold mb-3 sm:mb-4 text-brand-gold" data-id="element-300">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-cream/90" data-id="element-301">
            Diseñado para vos si querés que tu hijo respire mejor esta semana
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8" data-id="element-302">
          {targets.map((target, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          scale: 1.02,
          transition: {
            duration: 0.2
          }
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.1
        }} className="bg-white/10 backdrop-blur-sm p-5 sm:p-6 md:p-8 rounded-2xl border border-white/20 hover:bg-white/15 transition cursor-default" data-id="element-303">
              <div className="bg-white p-3 rounded-xl inline-block mb-4 sm:mb-6 shadow-sm" data-id="element-304">
                {target.icon}
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3" data-id="element-305">
                {target.title}
              </h3>
              <p className="text-cream/80 leading-relaxed text-sm sm:text-base" data-id="element-306">
                {target.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-10 sm:mt-14 md:mt-16 text-center" data-id="element-307">
          <a href="#pricing" className="inline-flex items-center gap-2 text-brand-gold hover:text-white font-bold text-base sm:text-lg transition group" data-id="element-308">
            ¿No estás segura si es para vos? Tenés 7 días de garantía total
            <span className="group-hover:translate-x-1 transition-transform" data-id="element-309">
              →
            </span>
          </a>
        </div>
      </div>
    </section>;
};